import { FC, ReactElement } from 'react';
import { Box, BoxProps, Flex, Text } from '@chakra-ui/react';
import ArrowLeft from '../Icons/ArrowLeft';
import { CbManageHeaderSkeleton } from './CbManageHeaderSkeleton';
export interface CbManageHeaderProps extends BoxProps {
  backArrowText?: string;
  colorScheme?: string;
  hasBackArrow?: boolean;
  hasColorEdit?: boolean;
  onBackArrowClick?: () => void;
  onColorChange?: (color: string) => void;
  title?: string;
  rightElement?: ReactElement | null;
  titleAdornment?: ReactElement | null;
  componentColor?: string;
  subText?: string;
  isLoading: boolean;
}
export const CbManageHeader: FC<CbManageHeaderProps> = ({
  backArrowText,
  colorScheme,
  hasBackArrow = false,
  onBackArrowClick,
  title,
  rightElement,
  titleAdornment,
  componentColor = 'white',
  subText,
  isLoading,
  ...props
}) => {
  if (isLoading) {
    return <CbManageHeaderSkeleton hasBackArrow={hasBackArrow} colorScheme={colorScheme} componentColor={componentColor} {...props} />;
  }
  return <Box backgroundColor={colorScheme} borderBottomRadius={{
    base: 24
  }} display="flex" justifyContent="space-between" paddingLeft={{
    base: 4,
    lg: 6
  }} paddingRight={{
    base: 4,
    lg: 8
  }} paddingTop={{
    base: 10,
    md: '80px'
  }} paddingBottom={{
    base: 4,
    md: 6
  }} alignItems={'center'} flexWrap={'wrap'} {...props} data-sentry-element="Box" data-sentry-component="CbManageHeader" data-sentry-source-file="CbManageHeader.tsx">
      <Flex alignItems={'center'} data-sentry-element="Flex" data-sentry-source-file="CbManageHeader.tsx">
        {hasBackArrow && <Box display="flex" alignItems="center" as="button" aria-label="Go Back" height={10} width={10} onClick={onBackArrowClick} opacity="0.6" textAlign="left" _hover={{
        opacity: '1'
      }}>
            <ArrowLeft color={componentColor} height={backArrowText ? '11px' : '16px'} width={backArrowText ? '11px' : '16px'} />
          </Box>}
        <Box data-sentry-element="Box" data-sentry-source-file="CbManageHeader.tsx">
          <Flex alignItems="center" justifyContent="space-between" width="100%" gap={4} data-sentry-element="Flex" data-sentry-source-file="CbManageHeader.tsx">
            <Text as={'h1'} fontSize={{
            base: 'md',
            lg: '4xl'
          }} fontFamily="codenext" color={componentColor} flexWrap="wrap" fontWeight="bold" overflow="auto" textOverflow="wrap" data-sentry-element="Text" data-sentry-source-file="CbManageHeader.tsx">
              {title}
            </Text>
            {titleAdornment}
          </Flex>
          <Text fontFamily="codenext" fontSize={{
          base: 'xl',
          md: 'lg'
        }} color={componentColor} maxW="40rem" overflow="hidden" whiteSpace="nowrap" textOverflow="ellipsis" data-sentry-element="Text" data-sentry-source-file="CbManageHeader.tsx">
            {subText}
          </Text>
        </Box>
      </Flex>
      {rightElement}
    </Box>;
};